// CareLogix™ ORACLE — Animated Healthcare Opportunity Radar (Phase 33 §7)
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { PALETTE, scoreColor } from "@/components/animation/MotionShared";

const OPPS = [
  { area: "Rural Telehealth",    score: 82 },
  { area: "Cardiology AI",       score: 76 },
  { area: "Maternal Health",     score: 71 },
  { area: "FQHC Expansion",      score: 68 },
  { area: "Pediatric Imaging",   score: 64 },
  { area: "Behavioral Health",   score: 58 },
  { area: "Pharmacy Automation", score: 55 },
  { area: "Chronic Care Coach",  score: 48 },
];

export default function HealthcareOpportunityRadar({ testid = "healthcare-opportunity-radar" }) {
  const [tick, setTick] = useState(0);
  useEffect(() => { const id = setInterval(() => setTick((t) => t + 1), 1500); return () => clearInterval(id); }, []);
  return (
    <section style={S.shell} data-testid={testid} aria-label="Healthcare Opportunity Radar">
      <header style={S.head}>
        <div style={S.eyebrow}>HEALTHCARE OPPORTUNITY RADAR™</div>
        <h3 style={S.title}>Public-information opportunity bands</h3>
      </header>
      <ul style={S.list}>
        {OPPS.map((o, i) => {
          const live = (i === tick % OPPS.length);
          return (
            <li key={o.area} style={{ ...S.row, borderColor: live ? PALETTE.greenAccent : "rgba(255,255,255,0.05)" }} data-testid={`${testid}-row-${o.area}`}>
              <span style={S.area}>{o.area}</span>
              <div style={S.barWrap}>
                <motion.div style={{ ...S.barFill, background: scoreColor(o.score) }} initial={{ width: 0 }} animate={{ width: `${o.score}%` }} transition={{ duration: 0.8 }} />
              </div>
              <span style={{ ...S.score, color: scoreColor(o.score) }}>{o.score}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}

const S = {
  shell:   { background: "linear-gradient(180deg, rgba(8,32,22,0.55), rgba(4,6,8,0.85))", border: `1px solid ${PALETTE.goldGlow}`, borderRadius: 14, padding: 12, color: PALETTE.slate3, display: "flex", flexDirection: "column", gap: 8 },
  head:    { display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8, flexWrap: "wrap" },
  eyebrow: { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: "0.22em" },
  title:   { margin: 0, color: PALETTE.goldBright, fontSize: 13 },
  list:    { margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 6 },
  row:     { display: "grid", gridTemplateColumns: "1fr 120px 36px", alignItems: "center", gap: 8, padding: "6px 8px", background: "rgba(255,255,255,0.02)", border: "1px solid", borderRadius: 8, transition: "border-color 240ms" },
  area:    { color: PALETTE.slate3, fontSize: 12.5 },
  barWrap: { height: 5, background: "rgba(255,255,255,0.06)", borderRadius: 2, overflow: "hidden" },
  barFill: { height: "100%" },
  score:   { fontFamily: "'Space Mono', monospace", fontSize: 11, fontWeight: 800, textAlign: "right" },
};
